import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

import moment from 'moment';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	postSearchSelectList: param => {
		return client
			.get(`${BASE_URL}/comm/common/custCode/v1/carSaleCustCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	async getList({ searchParams, currentPage, pageUnit }) {

		/*날짜 포멧변환*/
		var strtMm01, endMm01;

		//console.log('값은>>>>', searchParams);

		if (searchParams.strtMm01) {
			strtMm01 = moment(searchParams.strtMm01).format('YYYYMMDD');
		} else {
			strtMm01 = '';
		}
		if (searchParams.endMm01) {
			endMm01 = moment(searchParams.endMm01).format('YYYYMMDD');
		} else {
			endMm01 = '';
		}
		
		const queryStr = objectToQueryString({
			srchMm03: searchParams.srchMm03, //srchMm03
			strtMm01: strtMm01, //strtMm01
			endMm01: endMm01, //endMm01
			pmcId: searchParams.pmcId,
			carVin: searchParams.carVin,
			cpnyNm: searchParams.cpnyNm,
			lastYn: searchParams.lastYn,
			licensePlate: searchParams.licensePlate,
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/mqy/qlty/carSaleMst/v1/carSaleMsts${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPopupList({ popupSearchParams }) {
		try {
			const queryStr = objectToQueryString({
				pmcId: popupSearchParams.pmcId,
				ipnNos: popupSearchParams.ipnNos,
				saveStatus: popupSearchParams.saveStatus
			});
			
			const response = await client.get(`${BASE_URL}/mqy/qlty/carSaleMst/v1/lists${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	/**한번에 공통 코드 부르기 */
	// async getCommCodesOnce() {
	// 	try {
	// 		const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/fwdCkuTestCustCodeLists`);
	// 		return response?.data;
	// 	} catch (error) {
	// 		throw error.response?.data;
	// 	}
	// },
	async saveData(params) {
		try {
			const pathVariables = `pmcId/${params.get('pmcId')}`;
			const response = await client.post(`${BASE_URL}/mqy/qlty/carSaleMst/v1/status/1/${pathVariables}`, params);
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async updateWrntStartDd(params) {
		try {
			const pathVariables = `pmcId/${params.pmcId}/ipnNos/${params.ipnNos}/wrntStrtDd`;
			const response = await client.post(`${BASE_URL}/mqy/qlty/carSaleMst/v1/status/2/${pathVariables}`, params);
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	
};
